import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TranslationContext } from "../contexts/TranslationContext";

const LangSwitcher = () => {
  const { selectedLanguage, setSelectedLanguage } = useContext(TranslationContext);
  const [isLangOpen, setIsLangOpen] = useState(false);
  const languageRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleLang = () => {
    setIsLangOpen(!isLangOpen);
  };

  const changeLanguage = (language) => {
    if (selectedLanguage !== language) {
      setSelectedLanguage(language);
      localStorage.setItem("selectedLanguage", language);

      // Get the current path and update it based on language selection
      const currentPath = location.pathname;

      // Route mappings for language switch
      const routes = {
        en: {
          "/accueil": "/home",
          "/se-connecter": "/login",
          "/enregistrer": "/register",
          "/congratulation": "/success",
          "/badge-premium": "/premium-badge",
          "/cgu": "/cgu",
          "/my-email-(donations)": "/my-email-(donations)",
          "/chatroom": "/chatroom",
          "/send-my-opinions": "/send-my-opinions",
        },
        fr: {
          "/home": "/accueil",
          "/login": "/se-connecter",
          "/register": "/enregistrer",
          "/success": "/congratulation",
          "/subscription": "/badge-premium",
          "/cgu": "/cgu",
          "/my-wallet": "/my-email-(donations)",
          "/chatroom": "/chatroom",
          "/send-messages": "/envoyer-mes-opinions",
        },
      };

      // Determine new path
      const updatedPath = routes[language][currentPath] || currentPath;

      // Navigate to new path without page reload
      navigate(updatedPath);
    }
    setIsLangOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (languageRef.current && !languageRef.current.contains(event.target)) {
        setIsLangOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="menu-container ms-3">
      <div className="language-switcher" ref={languageRef}>
        <button className="language-button menu-button" onClick={toggleLang}>
          <img
            src={selectedLanguage === "fr" ? "../images/fr.png" : "../images/en.png"}
            alt={selectedLanguage === "fr" ? "French" : "English"}
            className="flag-icon"
          />{" "}
          {selectedLanguage === "fr" ? "Français" : "English"}{" "}
          <span className="arrow text-white">
            <i className="ri-arrow-down-s-line"></i>
          </span>
        </button>
        {isLangOpen && (
          <div className="dropdown-language dropdown-menus">
            <span className="language-option menu-item" onClick={() => changeLanguage("fr")}>
              <img src="../images/fr.png" alt="French" className="flag-icon" /> Français
            </span>
            <span className="language-option menu-item" onClick={() => changeLanguage("en")}>
              <img src="../images/en.png" alt="English" className="flag-icon" /> English
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default LangSwitcher;
